import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Rvsf } from '../rvsf';
import { LocalStorageService } from './localstorage-service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class RvsfInitService {
  private rvsfConfig = signal<any | null>(null);

  constructor(
    private rvsfService: Rvsf,
    @Inject(PLATFORM_ID) private platformId: Object,
    private localStorageService: LocalStorageService,
  ) {}

  /** Fetch tenant config by subdomain */
  loadTenantConfig() {
    let subdomain;
    if (isPlatformBrowser(this.platformId)) {
      subdomain = window.location.hostname;
    }

    if (!subdomain) {
      return;
    }

    this.rvsfService.fetchRvsfDetailsByUrl(subdomain).subscribe({
      next: (res: any) => {
        this.rvsfConfig.set(res.data);
        if (isPlatformBrowser(this.platformId)) {
          this.localStorageService.set('rvsfDetails', res.data);
        }
        // console.log('Details ', res.data);
      },
      error: (err) => {}
    });
  }

  /** Signal to consume in components */
  config() {
    return this.rvsfConfig.asReadonly();
  }
}
